import { HttpBodyReqPaginationModel } from "./util";

export class BillingParamReqModel extends HttpBodyReqPaginationModel {
	public filter: string;
	public platform: string;
	public clientId: string;

	constructor() {
		super();
	}

	public convert(): any {
		return {
			filter: this.filter,
			platform: this.platform,
			clientId: this.clientId,
			pageNo: String(this.pageNo),
			pageSize: String(this.pageSize),
		};
	}
}
